"use client"
import { useState } from "react"
import { laminateSheets, SHEET_SQFT } from "@/lib/seo/calculators"
import { plural } from "@/lib/seo/format"
import { inputClass } from "@/components/site/page-kit"
import { T } from "@/components/seo/type"

const num = (s: string) => (s.trim() === "" ? NaN : Number(s))

export function LaminateSheetsCalculator() {
  const [width, setWidth] = useState("8")
  const [height, setHeight] = useState("7")
  const [sides, setSides] = useState<1 | 2>(1)
  const out = laminateSheets({ widthFt: num(width), heightFt: num(height), sides })
  return (
    <form className="grid gap-4 md:grid-cols-[1fr_1fr_1fr_auto] md:items-end" onSubmit={(e) => e.preventDefault()} aria-describedby="laminate-sheets-result">
      <label className="flex flex-col gap-1.5"><span className={T.label}>Shutter width (ft)</span><input className={inputClass} inputMode="decimal" value={width} onChange={(e) => setWidth(e.target.value)} /></label>
      <label className="flex flex-col gap-1.5"><span className={T.label}>Shutter height (ft)</span><input className={inputClass} inputMode="decimal" value={height} onChange={(e) => setHeight(e.target.value)} /></label>
      <label className="flex flex-col gap-1.5"><span className={T.label}>Faces to cover</span>
        <select className={inputClass} value={sides} onChange={(e) => setSides(Number(e.target.value) as 1 | 2)}><option value={1}>Outside only</option><option value={2}>Both sides</option></select>
      </label>
      <p id="laminate-sheets-result" aria-live="polite" className="rounded-xl bg-hv-paper p-4 text-hv-ink md:min-w-[220px]">
        {out ? <><span className={T.figure}>{plural(out.sheets, "sheet")}</span><br /><span className="mt-1.5 inline-block text-sm leading-relaxed text-hv-soft">{out.areaSqft} sq ft plus 10% wastage, {SHEET_SQFT} sq ft per 8 x 4 ft sheet</span></> : <span className="text-sm text-hv-soft">Enter a width and height above 0.</span>}
      </p>
    </form>
  )
}
